import React from 'react';
import { Fade, IconButton, Snackbar } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';

export type SnackbarType = 'success' | 'error' | 'copy' | 'feedback' | 'notification';

interface NotificationSnackbarProps {
  open: boolean;
  onClose: () => void;
  message?: string;
  type?: SnackbarType;
  autoHideDuration?: number;
  height?: string;
  marginBottom?: string;
}

const getDefaultMessage = (type?: SnackbarType): string => {
  switch (type) {
    case 'copy':
      return 'Copied to clipboard!';
    case 'error':
      return 'Failed to copy';
    case 'feedback':
      return 'AI feedback submitted successfully!';
    default:
      return 'Success!';
  }
};

const getBackgroundColor = (type?: SnackbarType): string => {
  switch (type) {
    case 'error':
      return 'error.main';
    case 'notification':
      return 'grey.900';
    case 'copy':
    case 'feedback':
    case 'success':
    default:
      return 'primary.main';
  }
};

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  open,
  onClose,
  message,
  type,
  autoHideDuration = 3000,
  height = '40px',
  marginBottom = '',
}) => {
  const displayMessage = message || getDefaultMessage(type);
  const backgroundColor = getBackgroundColor(type);

  return (
    <Snackbar
      open={open}
      onClose={onClose}
      TransitionComponent={Fade}
      message={displayMessage}
      key={`NotificationSnackbar-${type}`}
      autoHideDuration={autoHideDuration}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      sx={{
        height: height,
        marginBottom: marginBottom,
        '& .MuiSnackbarContent-root': {
          padding: '2px 16px',
          backgroundColor,
        },
      }}
      action={
        <IconButton size="small" aria-label="Close notification" onClick={onClose}>
          <CloseOutlined fontSize="small" sx={{ fill: 'white' }} />
        </IconButton>
      }
    />
  );
};

export default NotificationSnackbar;
